import React from 'react';

// TODO Loading state while getting auth state
const AuthStateLoading = () => (
  <>
  </>
);

export default AuthStateLoading;
